<div class="variables-block">
	<span class="title-content" translate>eorder.product.variables.title</span><br>
	<span *ngFor="let v of dialogContent.variables">- {{v}}<br></span>
</div>